import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ProgressBar = () => {
  const percentage = useSelector(
    (store: { ID: { percentage: number } }) => store.ID.percentage
  );
  const totalStacks = 5;
  const filledStacks = Math.round((percentage / 100) * totalStacks);

  return (
    <div style={{ display: "flex", gap: "5px" }}>
      {Array.from({ length: totalStacks }).map((_, index) => (
        <div
          key={index}
          style={{
            width: "100%", // Each stack is 100% of the container width
            height: "5px",
            backgroundColor: index < filledStacks ? "#ffffff" : "#FFD100",
            borderRadius: "20px",
            transition: "background-color 0.5s ease", // Smooth transition for filling
          }}
        ></div>
      ))}
    </div>
  );
};

const FinishCard = () => {
  const navigate = useNavigate();

  const percentage = useSelector(
    (store: { ID: { percentage: number } }) => store.ID.percentage
  );

  const totalItems = useSelector(
    (store: { ID: { totalItems: number } }) => store.ID.totalItems
  );

  const totalAmount = useSelector(
    (store: { ID: { cartValuePrice: number } }) => store.ID.cartValuePrice
  );

  const tipValue = useSelector(
    (store: { ID: { tipValue: number } }) => store.ID.tipValue
  );
  const handleFinishApplication = () => {
    if (percentage === 90) {
      navigate("/payment");
    } else if (percentage < 90) {
      navigate("/uploadocument");
    }
  };

  return (
    percentage < 100 &&
    percentage > 40 &&
    totalItems !== 0 && (
      <div className="p-4  bg-dark rounded  mb-3 application-time d-none">
        <ProgressBar />
        <div className="font-14 text-white ff-semibold mb-3 mt-2">
          {percentage}% Complete{" "}
        </div>
        <div className="font-14 text-white ff-semibold mb-3">
          Continue to finish the the process
        </div>

        <div>
          <ul className="list-style-disc ms-4" style={{ listStyle: "disc" }}>
            <li className="font-14 ff-medium text-white mb-2">
              {totalItems} Items in cart
            </li>
            <li className="font-14 ff-medium text-white mb-2">
              Total <span className="ff-currency ff-medium font-16"></span>
              {Number(tipValue) >= 5 ? (
                <>{(totalAmount + (Number(tipValue) || 0)).toFixed(2)}</>
              ) : (
                <>{totalAmount.toFixed(2)}</>
              )}
            </li>
            {/* <li className="font-14 ff-medium text-green mb-2">
                Get 30% OFF if booked within 12 mins
              </li>
              <li className="font-14 ff-medium  text-white mb-2">
                24/7 customer support
              </li> */}
          </ul>
        </div>

        <button
          className="btn btn-primary  w-75 font-14 ff-semibold py-3  bt--cart"
          onClick={handleFinishApplication}
        >
          Finish Application
        </button>
      </div>
    )
  );
};

export default FinishCard;
